var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_star_24px",
    transform: "translate(-2 -2)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,47.81,50.54,59,45.62,37.91,62,23.72,40.43,21.89,32,2,23.57,21.89,2,23.72,18.38,37.91,13.46,59Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.49093627929688 50.67692565917969 L 41.17609024047852 36.46753311157227 L 52.2153434753418 26.90423583984375 L 37.68840026855469 25.67176628112793 L 32 12.25037956237793 L 26.31159973144531 25.67176628112793 L 11.78465747833252 26.90423583984375 L 22.82391166687012 36.46753311157227 L 19.50906372070312 50.67692565917969 L 32 43.13790130615234 L 44.49093627929688 50.67692565917969 M 50.54000091552734 59 L 32 47.81000137329102 L 13.46000003814697 59 L 18.3799991607666 37.90999984741211 L 2 23.71999931335449 L 23.56999969482422 21.88999938964844 L 32 2 L 40.43000030517578 21.88999938964844 L 62 23.71999931335449 L 45.61999893188477 37.90999984741211 L 50.54000091552734 59 Z",
    stroke: "none",
    fill: "#fa840e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.bb80e1b4e6fb2a88671273642b9f602a.svg";
export { ForwardRef as ReactComponent };